import { UIConfig } from "@dytesdk/ui-kit";
import DyteClient from "@dytesdk/web-core";

import { useMeetingTranscriptById } from "../../../../../hooks/useMeetingTranscript";
import { CustomStates, SetStates } from "../../../../../types/dyte";
import InMeeting from "./InMeeting";
import MeetingLoading from "./MeetingLoading";

function MeetingSetup({
  meeting,
  config,
  states,
  setStates,
  sessionId,
  conversationPrompts,
}: {
  meeting: DyteClient;
  config: UIConfig;
  states: CustomStates;
  setStates: SetStates;
  sessionId: string;
  conversationPrompts: string[];
}) {
  // We're fetching the meeting transcript to allow navigating away from the meeting page and coming back to it
  const { data: meetingTranscript, isLoading: isMeetingTranscriptLoading } =
    useMeetingTranscriptById(sessionId);

  if (states.meeting === "joined" && !isMeetingTranscriptLoading) {
    return (
      <InMeeting
        meeting={meeting}
        config={config}
        states={states}
        setStates={setStates}
        sessionId={sessionId}
        conversationPrompts={conversationPrompts}
        meetingTranscript={
          meetingTranscript || {
            uuid: sessionId,
            session_id: sessionId,
            type: "transcript",
            content: [],
          }
        }
      />
    );
  } else {
    return <MeetingLoading />;
  }
}

export default MeetingSetup;
